export class StatementSendUnconfirmedError extends Error {
  constructor() {
    super(
      'We could not confirm whether the statement finished sending. It may still appear in the Contact activity or Billing Sent Items. Close this dialog and verify before trying again.',
    );
    this.name = 'StatementSendUnconfirmedError';
  }
}

export function isStatementSendUnconfirmedError(
  error: unknown,
): error is StatementSendUnconfirmedError {
  return error instanceof StatementSendUnconfirmedError;
}
